import { dateStringToDate } from "@greeter/date";
import * as z from "zod";

export const VenueFeatureFlagSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string(),
  data: z.any(),
  active: z.boolean().default(false),
  createdAt: z.string().transform((s) => new Date(s)),
  updatedAt: z.string().transform((s) => new Date(s)),
});

export type VenueFeatureFlag = z.infer<typeof VenueFeatureFlagSchema>;
